// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aDdQ","rootMobile":"styles_rootMobile__2xAPP"};